module.exports = __webpack_public_path__ + "static/media/TN-Men-Pants-v2.0.7031b9b8.svg";